// @flow

import createStorage from "./EncryptedStorage";
import { encryption } from "./LocalStorage";

export const SessionStorage = window.sessionStorage && createStorage(window.sessionStorage, { encryption });

export default SessionStorage;
